import React, {useContext, useEffect, useState} from 'react';
import {ContextServicesFeaturesTable} from "../../context/ContextServicesFeaturesTable";

import styles from './ComponentServicesFeaturesTable.scss';
import DomainLabel from "../../common/primitives/DomainLabel";
import RedTooltip from "../../common/primitives/RedTooltip";
import HoverTooltip, {HoverTooltipStyles} from "../../common/primitives/HoverTooltip";
import plusImg from './img/plus_green.png';
import minusImg from './img/minus_red.png';
import Button from "../../common/primitives/Button";
import buttons from '../../common/primitives/Button.scss';
import {ContextServicePrice} from "../../context/ContextServicePriceProvider";
import Price, {FormatPrice} from "../../common/primitives/Price";
import RenderIf from "../../common/primitives/RenderIf/RenderIf.jsx";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import PropTypes from "prop-types";
import {isMobileHook} from '../../common/hooks/isMobileHook';
import {_hasProperty} from '../../common/helpers/HelperFunc';
import {__t} from '../../common/lang/text-resource.js';

function OnMouseEnterCharName(ttpId) {
	if (document.getElementById(ttpId)) {
		document.getElementById(ttpId).style.display = 'inline-block';
	}
}

function OnMouseOutCharName() {
	const elems = document.getElementsByClassName(HoverTooltipStyles.container);

	[].forEach.call(elems, function (el) {
		el.style.display = 'none';
	});
}


const serviceIpServiceMap = {
	plan_01: 'ip_address_new_02',
	plan_02: 'ip_address_new_01',
	plan_03: 'ip_address_new_01',
};

const serviceSEOServiceMap = {
	plan_01: 'srch_eng_01',
	plan_02: 'srch_eng_02',
	plan_03: 'srch_eng_02',
};


const ComponentServicesFeaturesTable = ({
											removeServiceTypeNameFromHeader,
											numberOfInitialVisibleRows,
											displayRenewPricesInTable,
											additionalInfoAfterTables,
											showCpanelAccountPrices,
											darkMoreButton,
											includeLastRowPrices
										}) => {
	const serviceFeaturesContext = useContext(ContextServicesFeaturesTable);
	/** @type ContextServicePriceProvider*/
	const servicePriceContex = useContext(ContextServicePrice);
	const prices = servicePriceContex.getForIds(['ip_address_new_01', 'ip_address_new_02', 'srch_eng_01', 'srch_eng_02', 'spam_expert_01']);
	const priceCpanelAccounts = servicePriceContex.getForIds(['cpanel_mvps_25acc', 'cpanel_mvps_45acc', 'cpanel_mvps_95acc']);

	const data = serviceFeaturesContext.contextData;
	const {serviceParams, groups, options, taxonomyCategory, arrPlans} = data;

	const [showAll, setShowAll] = useState(false);

	const [selectedMobileService, setSelectedMobileService] = useState(options[0].value);
	const [showMobileOptions, setShowMobileOptions] = useState(false);

	const isMobile = isMobileHook(500);

	useEffect(() => {
		if (!isMobile && showMobileOptions) {
			setShowMobileOptions(false);
		}
	}, [isMobile, showMobileOptions])

	const lastRowPrices = () => {
		const plansPrices = servicePriceContex.getForIds(arrPlans);
		return (
		  <div className={styles.lastRowPricesContainer}>
			  <table>
				  <tbody>
				  <tr>
					  <td/>
					  <td>
						  <Price
							valueClass={styles.priceClass}
							currencyClass={styles.currencyClass}
							value={plansPrices[options[0].value][12].monthlyPriceNew}
							currency={plansPrices[options[0].value][12].currency}/>{__t('/мес')}
					  </td>
					  <td>
						  <Price
							valueClass={styles.priceClass}
							currencyClass={styles.currencyClass}
							value={plansPrices[options[1].value][12].monthlyPriceNew}
							currency={plansPrices[options[1].value][12].currency}/>{__t('/мес')}
					  </td>
					  <td>
						  <Price
							valueClass={styles.priceClass}
							currencyClass={styles.currencyClass}
							value={plansPrices[options[2].value][12].monthlyPriceNew}
							currency={plansPrices[options[2].value][12].currency}/>{__t('/мес')}
					  </td>
				  </tr>
				  </tbody>
			  </table>
		  </div>

		)
	}
	const getServiceHeaderCol = (option, onClickShowMenu) => {
		const customNamesMap = {
			gdpr_protect_1_1: 'Essential',
			gdpr_protect_2_1: 'Advanced',
			gdpr_protect_3_1: 'Ultimate',
		};

		let optionLabel = removeServiceTypeNameFromHeader === true ? option.label.replace(data.serviceTypeName, '').trim() : option.label;
		if (!!customNamesMap[option.value]) {
			optionLabel = customNamesMap[option.value];
		}

		const onClickMobile = () => {
			if (onClickShowMenu === true) {
				setShowMobileOptions(!showMobileOptions);
			} else {
				setSelectedMobileService(option.value);
				setShowMobileOptions(false);
			}
		}

		if (isMobile) {
			return (
			  <div onClick={onClickMobile} className={`${styles.service_header} ${styles[option.value]}`}
				   key={option.value + '_header'}>
				  {optionLabel} <RenderIf condition={onClickShowMenu}>
				  <div className={styles.dropdown}/>
			  </RenderIf>
			  </div>
			)
		}
		return (
		  <th className={`${styles.service_header} ${styles[option.value]}`} key={option.value + '_header'}>
			  {optionLabel}
		  </th>
		)
	}
	const getTableHeader = (firstColText) => {

		if (isMobile) {
			return <>
				<thead>
				<tr>
					<th>{firstColText}</th>
					<th style={{position: 'relative'}}>
						{getServiceHeaderCol(options.find(option => option.value === selectedMobileService), true)}
						{showMobileOptions ? <div
						  className={styles.optionsContainer}>{options.map((option) => getServiceHeaderCol(option))} </div> : null}
					</th>
				</tr>
				</thead>

			</>
		}
		return <>
			<thead>
			<tr>
				<th>{firstColText}</th>
				{options.map((option) => getServiceHeaderCol(option))}
			</tr>
			</thead>

		</>
	}

	const getRenewPricesTable = () => {

		const firstPrice = servicePriceContex.getForId(options[0].value);
		const supportPrice = servicePriceContex.getForId('shopiko_support_01');

		return <div key='renew_prices' className={!showAll ? styles.hidden : ''}>
			<div>
				<h2 className="h2 gttp">
					{__t('Цени за подновяване')}<RenderIf
				  condition={options[0].value === 'plan_gomba_shop_01'}>*</RenderIf>
				</h2>
			</div>
			<div
			  className={`${styles.tableContainer}  js-features-table-container`}
			  data-group-id='renew-prices'>

				<table className='js-features-table'>
					{getTableHeader(__t('Период:'))}
					<tbody>
					{
						Object.keys(firstPrice).map((key) => {
							return (
							  <tr key={key}>
								  <td>{firstPrice[key].term}</td>
								  {
									  options.map((option, kk) => {
										  if (isMobile && option.value !== selectedMobileService) {
											  return null;
										  }
										  const prices = servicePriceContex.getForId(option.value);
										  if (!_hasProperty(prices, key)) {
											  return <td key={kk}></td>
										  }
										  if (options[0].value === 'plan_gomba_shop_01') {
											  return (
												<td key={kk}>
													<Price
													  value={parseFloat(parseFloat(prices[key].priceRenew) + parseFloat(supportPrice[key].priceRenew)).toFixed(2)}
													  currency={prices[key].currency}/>
													{SHVO.showEuroPrices && <>
														<Price
														  value={parseFloat(parseFloat(prices[key].priceRenewEUR) + parseFloat(supportPrice[key].priceRenew)).toFixed(2)}
														  currency={prices[key].currencyEUR}/>
													</>}
												</td>)
										  }
										  if (options[0].value === 'gdpr_protect_1_1') {
											  return (
												<td key={kk}>
													от&nbsp;
													<Price
													  value={prices[key].priceRenew}
													  currency={prices[key].currency}/>
													{SHVO.showEuroPrices && <>
														<br/>
														<Price
														  value={prices[key].priceRenewEUR}
														  currency={prices[key].currencyEUR}/>
													</>}
												</td>)
										  }
										  return (
											<td key={kk}>
												<Price
												  value={prices[key].priceRenew}
												  currency={prices[key].currency}/>
												{SHVO.showEuroPrices && <>
													<br/>
													<Price
													  value={prices[key].priceRenewEUR}
													  currency={prices[key].currencyEUR}/>
												</>}
											</td>)
									  })
								  }
							  </tr>
							)
						})
					}
					<RenderIf
					  condition={options[0].value === 'plan_gomba_shop_01'}>
						<tr>
							<td colSpan={4}>
								<div className={!showAll ? styles.hidden : ''}>
									<p className={styles.supportPricesLegend}>
										{__t('*Цените за подновяване са с включена поддръжка Basic.')}
									</p>
								</div>
							</td>
						</tr>
					</RenderIf>
					</tbody>
				</table>
			</div>
		</div>
	}

	return (
	  <div className={`${styles.container} ${includeLastRowPrices ? styles.withLastRowPrices : null}`}>
		  {
			  groups.map((group, key) => {
				  return (
					<div key={key} className={key !== 0 && !showAll ? styles.hidden : ''}>
						{
						  group.group_url && <a id={group.group_url}/>
						}
						<div>
							<h2 className="h2 gttp">
								{
									group.group_hidden === 1 ?
									  <Button
										value={group.group_name_multilang}
										className={`${buttons.buttonLink} ${styles.hiddenGroup}`}
										onClick={() => {
											const table = document.querySelectorAll(`[data-group-id="${group.group_id}"]`)[0];
											if (table.classList.contains(styles.hidden)) {
												table.classList.remove(styles.hidden);
											} else {
												table.classList.add(styles.hidden);
											}
										}}/>
									  : group.group_name_multilang
								}
								{
									group.group_new_prop ? <DomainLabel mode={'red'} text={__t('ново')}/> : ''
								}
							</h2>
						</div>


						<div
						  className={`${styles.tableContainer} ${group.group_hidden === 1 && styles.hidden} js-features-table-container`}
						  data-group-id={group.group_id}>
							<table className='js-features-table'>
								{getTableHeader(__t('Характеристика:'))}
								<tbody>
								{
								  Object.keys(serviceParams[group.group_id]).length > 0 && serviceParams[group.group_id][options[0].value].length > 0 && serviceParams[group.group_id][options[0].value].map((param, kk) => {

									  if (isMobile) {
										  param.hasMutual = false;
									  }
									  let value = <span
										dangerouslySetInnerHTML={{__html: param.char_val_value}}/>;

									  if (param.char_id === 'plan_ip_address_price' || param.char_id === 'e0b2ba0d77366516a9ca61239d35caae') {
										  param.hasMutual = true;

										  if (isMobile) {
											  param.hasMutual = false;
										  }

										  value = <div>
											  <Price
												value={prices[serviceIpServiceMap[options[0].value]][12].monthlyPriceNew}
												currency={prices[serviceIpServiceMap[options[0].value]][12].currency}
											  />
											  {SHVO.showEuroPrices && <>
												  &nbsp;/&nbsp;
												  <Price
													value={prices[serviceIpServiceMap[options[0].value]][12].monthlyPriceNewEUR}
													currency={"EUR"}
												  />
											  </>}&nbsp;
											  {__t('на месец за всички планове')}
										  </div>
									  }
									  if (param.char_id === 'plan_seo_register' || param.char_id === 'ad8210a59730abb9703150ee534f8f39') {
										  param.hasMutual = true;

										  if (isMobile) {
											  param.hasMutual = false;
										  }

										  value = <div>
											  <Price
												value={prices[serviceSEOServiceMap[options[0].value]][12].priceNew}
												currency={prices[serviceSEOServiceMap[options[0].value]][12].currency}
											  />
											  {SHVO.showEuroPrices && <>
												  &nbsp;/&nbsp;
												  <Price
													value={prices[serviceSEOServiceMap[options[0].value]][12].priceNewEUR}
													currency={"EUR"}
												  />
											  </>}&nbsp;
											  {__t('еднократно за всички планове')}
										  </div>

									  }
									  if (param.char_id === 'qen487s8szs12m') {
										  param.hasMutual = true;

										  if (isMobile) {
											  param.hasMutual = false;
										  }

										  value = <div>
											  <Price
												value={prices['spam_expert_01'][12].priceNew}
												currency={prices['spam_expert_01'][12].currency}
											  />
											  {SHVO.showEuroPrices && <>
												  &nbsp;/&nbsp;
												  <Price
													value={prices['spam_expert_01'][12].priceNewEUR}
													currency={"EUR"}
												  />
											  </>}&nbsp;
											  {__t('на година за всички планове')}
										  </div>
									  }
									  return (
										<tr key={kk}
											className={kk > numberOfInitialVisibleRows - 1 && !showAll ? styles.hidden : kk === numberOfInitialVisibleRows - 1 && !showAll ? styles.lastVisibleRow : ''}>
											<td
											  onMouseLeave={OnMouseOutCharName}>
											<span
											  onMouseOver={() => OnMouseEnterCharName(`tp${param.char_id}`)}
											  dangerouslySetInnerHTML={{
												  __html: param.char_name
											  }}/>
												{
													param.char_bracket_caption ?
													  <span
														className={styles.extra_desc}> {param.char_bracket_caption_multilang}</span> : ''
												}
												{
													param.char_tooltip ?
													  <HoverTooltip tooltip={param.char_tooltip}
																	name={`tp${param.char_id}`}/> : ''
												}
												{
													param.char_new_prop ?
													  <DomainLabel mode={'red'} text={__t('ново')}/> : ''
												}
											</td>
											<RenderIf
											  condition={!isMobile || options[0].value === selectedMobileService}>
												<td className={param.char_val_is_nowrapped ? '' : ''}
													colSpan={param.hasMutual === true ? options.length : 1}
													data-layout={param.hasMutual === true ? 'text-center' : ''}>
													{
														param.char_val_value_is_tooltip ?
														  <RedTooltip
															title={__t('Кликнете за повече информация')}
															name={`ttp_${param.char_val_id}_${options[0].value}`}
															tooltip={param.char_val_value}/>
														  :
														  param.char_val_value === '+' ?
															<img src={plusImg} alt="+"/>
															:
															param.char_val_value === '-' ?
															  <img src={minusImg} alt="-"/>
															  :
															  value
													}
													{

														param.char_val_new_prop ?
														  <DomainLabel mode={'red'} text={__t('ново')}/> : ''
													}
												</td>
											</RenderIf>
											{
											  param.hasMutual !== true && options.map((option, kkk) => {
												  if (isMobile && option.value !== selectedMobileService) {
													  return null;
												  }
												  if (kkk !== 0) {
													  const charValId = serviceParams[group.group_id][option.value][param.char_id][0].char_val_id;
													  const valueClear = serviceParams[group.group_id][option.value][param.char_id][0].char_val_value;
													  const isTooltip = serviceParams[group.group_id][option.value][param.char_id][0].char_val_value_is_tooltip;
													  const isNew = serviceParams[group.group_id][option.value][param.char_id][0].char_val_new_prop;
													  let isNW = serviceParams[group.group_id][option.value][param.char_id][0].char_val_is_nowrapped;

													  let value = <span
														dangerouslySetInnerHTML={{__html: valueClear}}/>;

													  if (param.char_id === 'plan_ip_address_price' || param.char_id === 'e0b2ba0d77366516a9ca61239d35caae') {
														  isNW = false;
														  value = <div>
															  <Price
																value={prices[serviceIpServiceMap[option.value]][12].monthlyPriceNew}
																currency={prices[serviceIpServiceMap[option.value]][12].currency}
															  />
															  {SHVO.showEuroPrices && <>
																  &nbsp;/&nbsp;
																  <Price
																	value={prices[serviceIpServiceMap[options[0].value]][12].monthlyPriceNewEUR}
																	currency={"EUR"}
																  />
															  </>}&nbsp;
															  {__t('на месец за всички планове')}
														  </div>
													  }
													  if (param.char_id === 'plan_seo_register' || param.char_id === 'ad8210a59730abb9703150ee534f8f39') {
														  value = <div>
															  <Price
																value={prices[serviceSEOServiceMap[option.value]][12].priceNew}
																currency={prices[serviceSEOServiceMap[option.value]][12].currency}
															  />
															  {SHVO.showEuroPrices && <>
																  &nbsp;/&nbsp;
																  <Price
																	value={prices[serviceSEOServiceMap[option.value]][12].priceNewEUR}
																	currency={"EUR"}
																  />
															  </>}&nbsp;
															  {__t('еднократно за всички планове')}
														  </div>
													  }
													  if (param.char_id === 'qen487s8szs12m') {
														  value = <div>
															  <Price
																value={prices['spam_expert_01'][12].priceNew}
																currency={prices['spam_expert_01'][12].currency}
															  />
															  {SHVO.showEuroPrices && <>
																  &nbsp;/&nbsp;
																  <Price
																	value={prices['spam_expert_01'][12].priceNewEUR}
																	currency={"EUR"}
																  />
															  </>}&nbsp;
															  {__t('на година за всички планове')}
														  </div>
													  }
													  return <td key={kkk} className={isNW ? '' : ''}>
														  {
															  isTooltip ?
																<RedTooltip
																  title={__t('Кликнете за повече информация')}
																  name={`ttp_${charValId}_${option.value}`}
																  tooltip={valueClear}/>
																:
																valueClear === '+' ?
																  <img src={plusImg} alt="+"/>
																  :
																  valueClear === '-' ?
																	<img src={minusImg} alt="-"/>
																	:
																	value
														  }
														  {
															  isNew ? <DomainLabel mode={'red'}
																				   text={__t('ново')}/> : ''
														  }
													  </td>
												  }
											  })
											}
										</tr>
									  )
								  })
								}
								</tbody>
							</table>
						</div>

					</div>
				  );

			  })
		  }

		  {
			additionalInfoAfterTables !== null &&
			<div className={!showAll ? styles.hidden : ''}
				 dangerouslySetInnerHTML={{__html: additionalInfoAfterTables}}/>
		  }

		  {
			showCpanelAccountPrices === true &&
			<div className={!showAll ? styles.hidden : ''}>
				<p className={styles.plansPS}>
					{__t('-броят-акаунти-на-сървъра-може-да-бъде-увеличен-сe62bdf')}
					<br/>
					{
					  priceCpanelAccounts['cpanel_mvps_25acc'] !== undefined &&
					  <>
						  {__t('+25 акаунта')} – {FormatPrice(parseFloat(priceCpanelAccounts['cpanel_mvps_25acc'][1].priceNewFormatted), priceCpanelAccounts['cpanel_mvps_25acc'][1].currency)}
						  {SHVO.showEuroPrices && <>
							  &nbsp;/ {FormatPrice(parseFloat(priceCpanelAccounts['cpanel_mvps_25acc'][1].priceNewEUR), priceCpanelAccounts['cpanel_mvps_25acc'][1].currencyEUR)}
						  </>}
						  <br/>
					  </>
					}
					{
					  priceCpanelAccounts['cpanel_mvps_45acc'] !== undefined &&
					  <>
						  {__t('+45 акаунта')} – {FormatPrice(parseFloat(priceCpanelAccounts['cpanel_mvps_45acc'][1].priceNewFormatted), priceCpanelAccounts['cpanel_mvps_45acc'][1].currency)}
						  {SHVO.showEuroPrices && <>
							  &nbsp;/ {FormatPrice(parseFloat(priceCpanelAccounts['cpanel_mvps_45acc'][1].priceNewEUR), priceCpanelAccounts['cpanel_mvps_45acc'][1].currencyEUR)}
						  </>}
						  <br/>
					  </>
					}
					{
					  priceCpanelAccounts['cpanel_mvps_95acc'] !== undefined &&
					  <>
						  {__t('+95 акаунта')} – {FormatPrice(parseFloat(priceCpanelAccounts['cpanel_mvps_95acc'][1].priceNewFormatted), priceCpanelAccounts['cpanel_mvps_95acc'][1].currency)}
						  {SHVO.showEuroPrices && <>
							  &nbsp;/ {FormatPrice(parseFloat(priceCpanelAccounts['cpanel_mvps_95acc'][1].priceNewEUR), priceCpanelAccounts['cpanel_mvps_95acc'][1].currencyEUR)}
						  </>}
						  <br/>
					  </>
					}
				</p>
			</div>
		  }

		  {displayRenewPricesInTable === true ? getRenewPricesTable() : ''}

		  {
			  showAll ?

				<div className={`${styles.featuresToggle} ${darkMoreButton ? styles.darkButton : null}`}>
					<Button
					  onClick={() => {
						  setShowAll(false);
						  HelperGoogleAnalytics.TrackNonInteractionEvent('Close list', 'Compare plans', 'Product Category/' + taxonomyCategory);
						  HelperGoogleAnalytics4.TrackEvent('Compare plans', 'Close list', 'Product Category/' + taxonomyCategory);
					  }}
					  name={'show_features'}
					  className={buttons.buttonImage}
					  value={__t('скрий характеристики')}/>
				</div>
				:
				<div className={`${styles.featuresToggle} ${darkMoreButton ? styles.darkButton : null}`}>
					<Button
					  onClick={() => {
						  setShowAll(true);
						  HelperGoogleAnalytics.TrackNonInteractionEvent('Open list', 'Compare plans', 'Product Category/' + taxonomyCategory);
						  HelperGoogleAnalytics4.TrackEvent('Compare plans', 'Open list', 'Product Category/' + taxonomyCategory);
					  }}
					  name={'show_features'}
					  className={buttons.buttonImage}
					  value={__t('всички характеристики')}/>
				</div>
		  }
		  {includeLastRowPrices === true ? lastRowPrices() : null}
	  </div>
	)
};

ComponentServicesFeaturesTable.defaultProps = {
	numberOfInitialVisibleRows: 3,
	additionalInfoAfterTables: null,
	showCpanelAccountPrices: false,
	darkModeButton: false,
	includeLastRowPrices: false
};
ComponentServicesFeaturesTable.propTypes = {
	numberOfInitialVisibleRows: PropTypes.number,
	darkMoreButton: PropTypes.bool,
	includeLastRowPrices: PropTypes.bool,
	removeServiceTypeNameFromHeader: PropTypes.bool,
	displayRenewPricesInTable: PropTypes.bool,
	additionalInfoAfterTables: PropTypes.string,
	showCpanelAccountPrices: PropTypes.bool
};
export default ComponentServicesFeaturesTable;